import { parseJson } from '@gnsx/genesys.js';

/**
 * Pure helpers for `.editor/build-stamp.json` (no store / engine imports).
 * Kept separate so unit tests can import without loading `editorStore`.
 */

/**
 * Parse `.editor/build-stamp.json` content and return its `builtAt` field.
 */
export function parseBuildStampBuiltAt(content: string): string | null {
  try {
    const parsed = parseJson(content) as unknown;
    if (typeof parsed !== 'object' || parsed === null) {
      return null;
    }
    const builtAt = (parsed as { builtAt?: unknown }).builtAt;
    return typeof builtAt === 'string' && builtAt.length > 0 ? builtAt : null;
  } catch {
    return null;
  }
}
